import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import PageHeader from 'shared/components/page-header/page-header';

import { MediaserverAudioSetting } from 'features/mediaserver-settings/domain/models/mediaserver-audio-setting';
import { MediaserverVideoSetting } from 'features/mediaserver-settings/domain/models/mediaserver-video-setting';
import useMediaserverAudioSetting from 'features/mediaserver-settings/hooks/mediaserver-audio-setting-hook';
import useMediaserverVideoSetting from 'features/mediaserver-settings/hooks/mediaserver-video-setting-hook';
import styles from 'features/mediaserver-settings/views/mediaserver-settings.module.scss';
import SettingTabs from 'features/settings/settings-tabs';

function MediaserverSettings(): ReactElement {
  const { t } = useTranslation('mediaserverSettings');

  const { mediaserverAudioSetting, setMediaserverAudioSetting } = useMediaserverAudioSetting();
  const { mediaserverVideoSetting, setMediaserverVideoSetting } = useMediaserverVideoSetting();

  const handleMediaserverAudioSettingChange = (event: SelectChangeEvent) => {
    setMediaserverAudioSetting(event.target.value as MediaserverAudioSetting);
  };

  const handleMediaserverVideoSettingChange = (event: SelectChangeEvent) => {
    setMediaserverVideoSetting(event.target.value as MediaserverVideoSetting);
  };

  return (
    <>
      <PageHeader title={t('pageHeaderTitle')} navigationComponent={<SettingTabs />} />

      <div className={styles.mediaserverSwitchContainer}>
        <FormControl>
          <InputLabel id="mediaserver-audio-label">{t('mediaserverAudioLabel')}</InputLabel>
          <Select
            labelId="mediaserver-audio-label"
            id="mediaserver-audio-select"
            value={mediaserverAudioSetting}
            label={t('mediaserverAudioLabel')}
            onChange={handleMediaserverAudioSettingChange}
            sx={{ width: 500 }}
          >
            <MenuItem value={MediaserverAudioSetting.MediaserverAudioDisabled}>{t('mediaserverAudioDisabledText')}</MenuItem>
            <MenuItem value={MediaserverAudioSetting.MediaserverAudioEnabled}>{t('mediaserverAudioEnabledText')}</MenuItem>
          </Select>
        </FormControl>
        <FormControl>
          <InputLabel id="mediaserver-video-label">{t('mediaserverVideoLabel')}</InputLabel>
          <Select
            labelId="mediaserver-video-label"
            id="mediaserver-video-select"
            value={mediaserverVideoSetting}
            label={t('mediaserverVideoLabel')}
            onChange={handleMediaserverVideoSettingChange}
            sx={{ width: 500 }}
          >
            <MenuItem value={MediaserverVideoSetting.MediaserverVideoDisabled}>{t('mediaserverVideoDisabledText')}</MenuItem>
            <MenuItem value={MediaserverVideoSetting.MediaserverVideoEnabled}>{t('mediaserverVideoEnabledText')}</MenuItem>
          </Select>
        </FormControl>
      </div>
    </>
  );
}

export default MediaserverSettings;
